import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import { useAppDispatch } from "../../../../Redux/hooks";
import { updateResponse } from "../../../../Redux/reducers/providerConsentSlice";

const datePickerFormats = ["DD/MM/YYYY", "MM/DD/YYYY"];
const dateTimePickerFormats = ["DD/MM/YYYY HH:mm", "MM/DD/YYYY HH:mm"];

const luxonFormats: Record<string, string> = {
  "DD/MM/YYYY": "dd/MM/yyyy",
  "MM/DD/YYYY": "MM/dd/yyyy",
  "DD/MM/YYYY HH:mm": "dd/MM/yyyy HH:mm",
  "MM/DD/YYYY HH:mm": "MM/dd/yyyy HH:mm",
};

type Props = {
  dateFormat: string;
  value?: string;
  blockId: string;
  editable: boolean;
  placeholder?: string;
};

const DateField = ({
  dateFormat,
  value,
  blockId,
  editable,
  placeholder = "Select date",
}: Props) => {
  const format = dateFormat!;
  const dispatch = useAppDispatch();

  const handleChange = (input: any) => {
    const val = input.toFormat(luxonFormats[format]);
    dispatch(
      updateResponse({
        blockId: blockId,
        key: "input",
        value: val,
      })
    );
  };

  return (
    <>
      {dateTimePickerFormats.includes(format) && (
        <DateTimePicker
          format={luxonFormats[format]}
          value={
            value ? DateTime.fromFormat(value, luxonFormats[format]) : null
          }
          onChange={(newValue: any) => {
            handleChange(newValue);
          }}
          timeSteps={{
            minutes: 1,
            seconds: 1,
          }}
          readOnly={!editable}
          slotProps={{
            textField: {
              sx: {
                width: {
                  md: 350,
                  xs: "100%",
                },
                maxWidth: "100%",
              },
              inputProps: {
                readOnly: true,
                placeholder,
              },
            },
          }}
        />
      )}
      {datePickerFormats.includes(format) && (
        <DatePicker
          views={
            format === "YYYY"
              ? ["year"]
              : format === "MM/YYYY"
              ? ["month", "year"]
              : undefined
          }
          format={luxonFormats[format]}
          value={
            value ? DateTime.fromFormat(value, luxonFormats[format]) : null
          }
          onChange={(newValue: any) => {
            handleChange(newValue);
          }}
          readOnly={!editable}
          slotProps={{
            textField: {
              sx: {
                width: {
                  md: 350,
                  xs: "100%",
                },
                maxWidth: "100%",
              },
              inputProps: {
                readOnly: true,
                placeholder,
              },
            },
          }}
        />
      )}
    </>
  );
};
export default DateField;
